import bugsnag from 'bugsnag-js';

const bugsnagClient = bugsnag('ff49323541f98126d646522cc2648e50');
if (process.env.NODE_ENV === 'development' && window) {
  window.bugsnagClient = bugsnagClient;
}
bugsnagClient.app.releaseStage = process.env.NODE_ENV;
bugsnagClient.app.version = process.env.REACT_APP_VERSION;

export default bugsnagClient;
